import type { WorkspaceConfigRequest } from "@/services/api/workspace-config/types";
import { resolveWindowTransparency } from "@/utils/windowTransparencyPreference";

/**
 * UI preferences that may be missing from older API payloads.
 * When the API omits a field (undefined), keep the local value so refresh
 * does not reset user choices.
 */
export function mergeWorkspaceConfigFromApi(
  apiConfig: WorkspaceConfigRequest,
  localConfig: WorkspaceConfigRequest | null | undefined,
): WorkspaceConfigRequest {
  if (!localConfig) {
    return apiConfig;
  }

  return {
    ...apiConfig,
    autoHideChrome:
      apiConfig.autoHideChrome ?? localConfig.autoHideChrome ?? false,
    windowTransparency: resolveWindowTransparency(apiConfig, localConfig),
    dockIconStyle: apiConfig.dockIconStyle ?? localConfig.dockIconStyle,
  };
}
